import { BETSLIP_STATUS } from './betslip-constants';
/**
 * Betslip types
 * We need to check each game what type is it
 * @type {{PREMATCH: string, LIVE: string, MIXED: string, VIRTUALS: string }}
 */
export const BETSLIP_TYPES = {
  PREMATCH: 'P',
  LIVE: 'L',
  MIXED: 'M',
  VIRTUALS: 'V'
};

export const MYBET_STATUS_CODES = {
  ALL_SETTLED: -5,
  NEGOTIATIONS: -2,
  ALL: -1,
  OPEN: 0,
  WON: 1,
  LOST: 2,
  REJECTED: 5,
  CASHOUT: 12,
  CASHBACK: 15,
};

// export const CASHOUT_STEPS = {
//   INITAL: 0,
//   CONFIRM: 1,
//   CONFIRMED: 2,
//   NEW_OFFER: 3,
//   DONE: 4,
// };

export const CASHOUT_ERROR_CODES = {
  // ErrorCode = 0 succefull cashout
  SUCCESS: 0,
  // ErrorCode = 1 error while trying to cashout
  ERROR: 1,
  // ErrorCode = 2 cashout became unavailable
  UNAVAILABLE: 2,
  // ErrorCode = 3 new cashout offer
  NEW_OFFER: 3,
};

export const DATE_FORMAT = 'YYYY-MM-DD';
export const MATCH_TYPES = [
  {
    text: 'Mobile.all',
    val: null,
  },
  {
    text: 'BetSlipMatchType.P',
    val: 'P',
  },
  {
    text: 'BetSlipMatchType.L',
    val: 'L',
  },
  {
    text: 'BetSlipMatchType.M',
    val: 'M',
  },
  {
    text: 'BetSlipMatchType.BB',
    val: 'BB',
  },
  {
    text: 'BetSlipMatchType.BO',
    val: 'BO',
  },
];

export const CASHOUT_ON_DEMAND_STEPS = {
  // inital step
  INITAL: 1,
  // waiting for check cashout response
  LOADING: 2,
  // confirm or cancel cashout
  CONFIRM: 3,
  // waiting for cashout response
  CASHING_OUT: 4,
  // cashout reponse returned new offer
  NEW_OFFER: 5,
  // cashout response returned Amount 0 or status code unavailable
  UNAVAILABLE: 6,
  // successful cashout
  DONE: 7,
  // check cashout returned CashoutAmout 0 (cashout is not available for this bet)
  DISABLED: 8,
};

/**
 * Map of bet status -> css class for mybets header mobile status
 */
export const MYBETS_STATUS_MOBILE_CLASS = {
  [BETSLIP_STATUS.WON]: 'bto-sb-mb-mybet-item-event-status-won',
  [BETSLIP_STATUS.LOST]: 'bto-sb-mb-mybet-item-event-status-lost',
  [BETSLIP_STATUS.PAID]: 'bto-sb-mb-mybet-item-event-status-paid',
  [BETSLIP_STATUS.HALFWON]: 'bto-sb-mb-mybet-item-event-status-halfwon',
  [BETSLIP_STATUS.HALFLOST]: 'bto-sb-mb-mybet-item-event-status-halflost',
  [BETSLIP_STATUS.VOID]: 'bto-sb-mb-mybet-item-event-status-void',
  [BETSLIP_STATUS.CANCELLED]: 'bto-sb-mb-mybet-item-event-status-cancelled',
  [BETSLIP_STATUS.REJECTED]: 'bto-sb-mb-mybet-item-event-status-rejected',
  [BETSLIP_STATUS.CACHEDOUT]: 'bto-sb-mb-mybet-item-event-status-cashout',
  [BETSLIP_STATUS.CASHBACK]: 'bto-sb-mb-mybet-item-event-status-cashback',
};

/**
 * Map of bet status -> object for generating status text in mybets header mobile
 */
export const MYBETS_STATUS_MOBILE_TEXT = {
  [BETSLIP_STATUS.PLACED]: { status: 'Mobile.Placed', showAmount: false },
  [BETSLIP_STATUS.WON]: { status: 'Mobile.Won', showAmount: true },
  [BETSLIP_STATUS.LOST]: { status: 'Mobile.Lost', showAmount: false },
  [BETSLIP_STATUS.PAID]: { status: 'Mobile.Paid', showAmount: true },
  [BETSLIP_STATUS.HALFWON]: { status: 'Mobile.HalfWon', showAmount: true },
  [BETSLIP_STATUS.HALFLOST]: { status: 'Mobile.HalfLost', showAmount: true },
  [BETSLIP_STATUS.VOID]: { status: 'Mobile.Void', showAmount: false },
  [BETSLIP_STATUS.CANCELLED]: { status: 'Mobile.Cancelled', showAmount: false },
  [BETSLIP_STATUS.REJECTED]: { status: 'Mobile.Rejected', showAmount: false },
  [BETSLIP_STATUS.CACHEDOUT]: { status: 'M.CashedOutAt', showAmount: true },
  [BETSLIP_STATUS.CASHBACK]: { status: 'Mobile.Cashback', showAmount: true },
};

/**
 * Map of bet status -> css class for mybets header mobile status
 */
export const MYBETS_STATUS_HISTORY_CLASS = {
  [BETSLIP_STATUS.WON]: 'bto-sb-event-won',
  [BETSLIP_STATUS.PAID]: 'bto-sb-event-paid',
  [BETSLIP_STATUS.HALFWON]: 'bto-sb-event-halfwon',
  [BETSLIP_STATUS.HALFLOST]: 'bto-sb-event-halflost',
  [BETSLIP_STATUS.LOST]: 'bto-sb-event-lost',
  [BETSLIP_STATUS.VOID]: 'bto-sb-event-void',
  [BETSLIP_STATUS.CANCELLED]: 'bto-sb-event-cancelled',
  [BETSLIP_STATUS.REJECTED]: 'bto-sb-event-rejected',
  [BETSLIP_STATUS.CACHEDOUT]: 'bto-sb-event-cashout',
  [BETSLIP_STATUS.CASHBACK]: 'bto-sb-event-cashback',
};

/**
 * List of statues that have returned amount
 */
export const MYBETS_SHOW_WON_STATUSES = [
  BETSLIP_STATUS.WON,
  BETSLIP_STATUS.PAID,
  BETSLIP_STATUS.HALFLOST,
  BETSLIP_STATUS.HALFWON,
  BETSLIP_STATUS.CACHEDOUT,
  BETSLIP_STATUS.CASHBACK,
];

/**
* List of statues that we are showing winning amount in mybet details
*/
export const MYBETS_SHOW_WINNINGS_STATUSES = [
  ...MYBETS_SHOW_WON_STATUSES,
  BETSLIP_STATUS.PLACED
];